import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import ProductCard from "@/components/ProductCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FILTERS = [
  { key: "all", label: "All Products" },
  { key: "life-stage", label: "Life-Stage & Reproductive" },
  { key: "everyday", label: "Everyday Wellness" },
  { key: "vegan", label: "100% Vegan" },
];

const Products = () => {
  const [products, setProducts] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const active = searchParams.get("collection") || "all";

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/products`).then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, []);

  const setFilter = (key) => {
    if (key === "all") setSearchParams({});
    else setSearchParams({ collection: key });
  };

  const filtered = active === "all" ? products : active === "vegan" ? products.filter((p) => p.vegan) : products.filter((p) => p.collection === active);

  return (
    <main data-testid="products-page" className="pt-[110px] bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-14 lg:py-16">
        <p className="text-xs font-semibold uppercase tracking-widest text-rose mb-3 inline-block border-l-2 border-gold pl-3">The full collection</p>
        <h1 className="font-display text-4xl lg:text-5xl font-medium tracking-tight text-ink">Shop all formulas</h1>
        <p className="text-gray-600 mt-4 max-w-2xl">
          Thirteen clinically-formulated supplements for every stage and need — each with fully transparent, per-serving ingredient dosages.
        </p>

        <div className="flex flex-wrap gap-2 mt-8 border-b border-gray-200 pb-5">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              data-testid={`filter-${f.key}`}
              className={`text-sm font-semibold px-4 py-2 rounded-md border transition-colors duration-200 ${
                active === f.key
                  ? "bg-ink text-white border-ink"
                  : "bg-white text-gray-600 border-gray-300 hover:border-ink hover:text-ink"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-10">
          {filtered.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </div>
    </main>
  );
};

export default Products;
